var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[(!_vm.is_anonymous_page)?_c('div',[_c('LogoPage')],1):_vm._e(),(_vm.is_anonymous_page)?_c('div',[_c('LogoPageAnonymous')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }